import React, {useState,useRef } from 'react';
import {Form, Button, Card} from 'react-bootstrap'
import axios from 'axios';
import OverLay from '../overlay';
import Popup from 'reactjs-popup';
import {useHistory} from 'react-router-dom';
import LoginByModal from './login_by_modal'

const EFranking=(props)=>{
    const history=useHistory()
    const [loginornot, setloginornot]=useState(false)

    const [selectstate, setselectstate]=useState('a')
    const [data, setdata]=useState({
        service_type:props.servicetype,
        state:'Maharastra',
        name_of_first_party:'',
        pan_no_first_party:'',
        address_of_first_party:'',
        name_of_second_party:'',
        pan_no_second_party:'',
        address_of_second_party:'',
        contact_no_second_party:'',
        stamp_duty_paid_by:'',
        contact_value:'',
        document_description:'',
        payment_method:'',
        delivery_address:''
    })
    const popupmodal=useRef()

    const [getrequestdata, setgetrequestdata]=useState({})
    const [indicator, setindecator]=useState(false)

    const [err, seterr]=useState({});
    const onhandleSubmit=()=>{
        let err={}
        if(data.name_of_first_party===''){
           err['name_of_first_party']='Please Enter Name of First Party' 
        }
        if(data.pan_no_first_party===''){
            err['pan_no_first_party']='Please Enter Pan No First Party' 
         }        
         if(data.address_of_first_party===''){
            err['address_of_first_party']='Please Enter Address of First Party' 
         }       
          if(data.name_of_second_party===''){
            err['name_of_second_party']='Please Enter Name of Second Party' 
         }        
         if(data.pan_no_second_party===''){
           err['pan_no_second_party']='Please Enter Pan No Second Party' 
        }        
        if(data.address_of_second_party===''){
            err['address_of_second_party']='Please Enter Address of Second Party' 
         }        
         if(data.contact_no_second_party===''){
           err['contact_no_second_party']='Please Enter Contact No Second Party' 
        }        
        if(data.stamp_duty_paid_by===''){
            err['stamp_duty_paid_by']='Please Select stamp duty paid by' 
         }       
        if(data.contact_value===''){
            err['contact_value']='Please Enter Contact Value' 
         }
         if(data.document_description===''){
            err['document_description']='Please Enter Document Description' 
         }
        if(data.payment_method===''){
        err['payment_method']='Please Enter Payment Method' 
        }
        if(data.delivery_address===''){
            err['delivery_address']='Please Enter Delivery Address' 
            }
        seterr(err)
        if(Object.keys(err).length===0){
            setindecator(true)
            axios.post('/save_e_franking_service', {
                data:data,
                user_id:props.userData.id,
                scheme_id:props.userData.corporate_id
            }).then((res)=>{
                setindecator(false)
                if(res.data){
                    setgetrequestdata(res.data)
                    popupmodal.current.open()

                }
            })
        }
    }
    // console.log('Franking=',props.userData.id)
    return(
        <div className='w-100'>
        <div className='form ' style={{
                  
            display:'flex',
            flexWrap:'wrap',
          
            alignItems:'start',
            justifyContent:'center',
            padding:"5% 10%"
        }}>



{/* column1 starts */}
<div className='column1 d-flex flex-column w-50  ' >
<div>
        <label>Select State:</label>
        <div>
            <input  className="form-control" onChange={()=>{}}  style={{width:300}} contentEditable="false" value={data.state}/>
        </div>
    </div>
    <div>
        <div>
            <label>Pancard Number of First Party</label>
        </div>
        <div>
            <input style={{width:300}} name='pan_no_first_party' value={data.pan_no_first_party}
                onChange={(ev)=>{
                    setdata({...data, pan_no_first_party:ev.target.value})
                    let nerr={...err}
                    nerr['pan_no_first_party']=''
                    seterr({...nerr})
                }} placeholder="Pancard Number" className="form-control"/>
        </div>
        {err['pan_no_first_party']&&
            <div>
                <span style={{color:'red'}}>{err['pan_no_first_party']}</span>
            </div>
        }
    </div>
    
    <div>
        <label>Name of First Party:</label>
        <div style={{display:'flex'}}>
            <input style={{width:300}} name='name_of_first_party' value={data.name_of_first_party}
            onChange={(ev)=>{
                setdata({...data, name_of_first_party:ev.target.value})
                let nerr={...err}
            nerr['name_of_first_party']=''
            seterr({...nerr})
    
            }} placeholder="Name" className="form-control"/>
           
        </div>
        {err['name_of_first_party']&&
            <div>
                <span style={{color:'red'}}>{err['name_of_first_party']}</span>
            </div>
        }
    </div>
    <div>
        <div>
            <label>Address of first Party</label>
        </div>
        <div>
            <textarea style={{width:300}} name={'address_of_first_party'}
            value={data.address_of_first_party}
            onChange={(ev)=>{
                setdata({...data, address_of_first_party:ev.target.value})
                let nerr={...err}
                nerr['address_of_first_party']=''
                seterr({...nerr})
            }} className="form-control"/>
        </div>
        {err['address_of_first_party']&&
            <div>
                <span style={{color:'red'}}>{err['address_of_first_party']}</span>
            </div>
        }
    </div>
    <div>
        <div>
            <label>Stamp Duty paid by</label>
        </div>
        <div style={{width:300, justifyContent:'space-between', display:'flex'}}>
            <span>
                <input type="radio" name="stamp_duty_paid_by" 
                name={'stamp_duty_paid_by'}
                value={'First Party'}
                onChange={(ev)=>{
                    setdata({...data, stamp_duty_paid_by:ev.target.value})
                    let nerr={...err}
                    nerr['stamp_duty_paid_by']=''
                    seterr({...nerr})
                }} aria-label="Stamp Duty paid by" />
                <br/>
                First Party
            </span>
            <span>
                <input type="radio" value='Second Party'
                onChange={(ev)=>{
                    setdata({...data, stamp_duty_paid_by:ev.target.value})
                    let nerr={...err}
                    nerr['stamp_duty_paid_by']=''
                    seterr({...nerr})
                }}
                 name="stamp_duty_paid_by" aria-label="Stamp Duty paid by"/>
                <br/>
                Second Party
            </span>
        </div>
        {err['stamp_duty_paid_by']&&
            <div>
                <span style={{color:'red'}}>{err['stamp_duty_paid_by']}</span>
            </div>
        }
    </div>
    <div>
        <div>
            <label>Document Description:</label>
        </div>
        <div>
            <textarea style={{width:300}} value={data.document_description} name={'document_description'}
            onChange={(ev)=>{
                setdata({...data, document_description:ev.target.value})
                let nerr={...err}
                nerr['document_description']=''
                seterr({...nerr})
            }}
            className="form-control"/>
        </div>
        {err['document_description']&&
            <div>
                <span style={{color:'red'}}>{err['document_description']}</span>
            </div>
        }
    </div>
    <div>
        <label>Delivery Address:</label>

        <textarea style={{width:300}} value={data.delivery_address}
        onChange={(ev)=>{
            
            setdata({...data, delivery_address:ev.target.value})
            let nerr={...err}
            nerr['delivery_address']=''
            seterr({...nerr})
        }} name={'delivery_address'} className="form-control"/>
        {err['delivery_address']&&
            <div>
                <span style={{color:'red'}}>{err['delivery_address']}</span>
            </div>
        }
    </div>
</div>
{/* column1 ends */}
{/* column2 starts */}
<div className='column2 d-flex flex-column w-50  '>
<div>
        <div>
            <label>Name of Second Party:</label>
        </div>
        <div style={{display:'flex'}}>
            <input style={{width:300}} name='name_of_second_party' value={data.name_of_second_party}
            onChange={(ev)=>{
                setdata({...data, name_of_second_party:ev.target.value})
                let nerr={...err}
                nerr['name_of_second_party']=''
                seterr({...nerr})
            }} placeholder="Name" className="form-control"/>
           
        </div>
        {err['name_of_second_party']&&
            <div>
                <span style={{color:'red'}}>{err['name_of_second_party']}</span>
            </div>
        }
    </div>
  <div>
        <div>
            <label>Pancard Number of Second Party</label>
        </div>
        <div>
            <input style={{width:300}} name='pan_no_second_party' value={data.pan_no_second_party}
                onChange={(ev)=>{
                    setdata({...data, pan_no_second_party:ev.target.value})
                    let nerr={...err}
                    nerr['pan_no_second_party']=''
                    seterr({...nerr})
                }} placeholder="Pancard Number" className="form-control"/>
        </div>
        {err['pan_no_second_party']&&
            <div>
                <span style={{color:'red'}}>{err['pan_no_second_party']}</span>
            </div>
        }
    </div>
    <div>
        <div>
            <label>Address of Second Party</label>
        </div>
        <div>
            <textarea style={{width:300}} name={'address_of_second_party'}
            value={data.address_of_second_party}
            onChange={(ev)=>{
                setdata({...data, address_of_second_party:ev.target.value})
                let nerr={...err}
                nerr['address_of_second_party']=''
                seterr({...nerr})
            }} className="form-control"/>
        </div>
        {err['address_of_second_party']&&
            <div>
                <span style={{color:'red'}}>{err['address_of_second_party']}</span>
            </div>
        }
    </div>
    <div>
        <div>
            <label>Contact Number Second Party</label>
        </div>
        <div>
            <input style={{width:300}} name={'contact_no_second_party'}
            value={data.contact_no_second_party}
            onChange={(ev)=>{
                setdata({...data, contact_no_second_party:ev.target.value})
                let nerr={...err}
                nerr['contact_no_second_party']=''
                seterr({...nerr})
            }} className="form-control"/>
        </div>
        {err['contact_no_second_party']&&
            <div>
                <span style={{color:'red'}}>{err['contact_no_second_party']}</span>
            </div>
        }
    </div>
    <div>
        <div>
            <label>Contract Value:</label>
        </div>
        <div>
            <input style={{width:300}} value={data.contact_value}
            onChange={(ev)=>{
                setdata({...data, contact_value:ev.target.value})
                let nerr={...err}
                nerr['contact_value']=''
                seterr({...nerr})
            }} name={'contact_value'} className="form-control"/>
        </div>
        {err['contact_value']&&
            <div>
                <span style={{color:'red'}}>{err['contact_value']}</span>
            </div>
        }
    </div>
    <div>
        <label>Payment Method:</label>
        <div style={{width:300, justifyContent:'space-between', display:'flex'}}>
            <span>
                <input type="radio" value={'Prepaid'}
                onChange={(ev)=>{
                    setdata({...data, payment_method:ev.target.value})
                    let nerr={...err}
                    nerr['payment_method']=''
                    seterr({...nerr})
                }} name="payment_method" aria-label="payment_method"/>
                <br/>
                Prepaid 
            </span>
            <span>
                <input type="radio" value='Post Paid'
                onChange={(ev)=>{
                    setdata({...data, payment_method:ev.target.value})
                    let nerr={...err}
                    nerr['payment_method']=''
                    seterr({...nerr})
                }} name="payment_method" aria-label="payment_method"/>
                <br/>
                Post Paid 
            </span>
            <span>
                <input type="radio" value='Wallet'
                onChange={(ev)=>{
                    setdata({...data, payment_method:ev.target.value})
                    let nerr={...err}
                    nerr['payment_method']=''
                    seterr({...nerr})
                }} name="payment_method" aria-label="payment_method"/>
                <br/>
                Wallet
            </span>
        </div>
        {err['payment_method']&&
            <div>
                <span style={{color:'red'}}>{err['payment_method']}</span>
            </div>
        }
    </div>
</div>
{/* column2 ends */}

</div>




        
   
   
   
  
    

   
   
   
    <div style={{textAlign:'center', width:'100%', paddingTop:20}}>
       
    {Object.keys(props.userData).length===0?
                    <Button  variant="warning" style={{color:'white',width:'150px', display:'inline', fontSize:20}}
                    onClick={(()=>{
                        setloginornot(true)
                    })}
                    >Login</Button>
                    
                    :
                    <Button type="submit"  onClick={()=>{
                        onhandleSubmit()
                    }} variant="warning" style={{color:'white',width:'150px', display:'inline', fontSize:20}} >Submit</Button>
                    }
   
    </div>
    <Popup
    ref={popupmodal}
    // trigger={<button className="button"> Open Modal </button>}
    modal
    nested>
    {close => (
        <div>
            {getrequestdata.message&&
                <h6 style={{
                    padding:33,
                    color:'blueviolet'
                }}>Created with Request ID {getrequestdata.text}</h6>
            }
          <div style={{display:'flex',alignItems:'center', justifyContent:'space-around'}}>
                <Button onClick={()=>{
                    close()
                    setdata({
                        service_type:props.servicetype,
                        state:'Maharastra',
                        name_of_first_party:'',
                        pan_no_first_party:'',
                        address_of_first_party:'',
                        name_of_second_party:'',
                        pan_no_second_party:'',
                        address_of_second_party:'',
                        contact_no_second_party:'',
                        stamp_duty_paid_by:'',
                        contact_value:'',
                        document_description:'',
                        payment_method:'',
                        delivery_address:''
                    })
                }}>Continue</Button>
                <Button onClick={()=>{
                    history.push('/reports')
                    history.go(0)
                }}>Go To The Reports</Button>
            </div>
        </div>
      )}
   
</Popup>
    <OverLay active={indicator}/>
    <LoginByModal loginClick={loginornot} propsStateData={data} login_not={true} closeModal={(ev)=>{
        console.log('props', props)
        setloginornot(false)
    }}/>
        </div>
    )
}
export default EFranking;